import React, { useCallback, useContext, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import aircraftApi from "../../../api/aircraft.api";
import { debounce } from "../../../services/utils";
import { BetterControlledAutocomplete, ControlledAutocomplete, ControlledTextField } from "../../Core/Form/ControlledFields";
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';
import { Grid, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import SkywatchInformationTooltip from "../../Core/Popover/SkywatchInformationTooltip";
import { DEBOUNCE_TIME } from "../../../Constants";


const AircraftModelAutocomplete = ({...props}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isLoading, setIsLoading] = useState(false);
    const [models, setModels] = useState([]);
    const { watch, reset, getValues } = useFormContext();
    const {locked_quote} = useContext(QuoteContextStore)

    const make = watch('make');
    const notFound = watch('make_model_not_found');

    useEffect(() => {
        setModels([]);
    }, [make])

    async function filter(make, model) {
        setIsLoading(true)
        if(!model) {
            const { data: { aircraft_models }} = await aircraftApi.getModels(make , "", "");
            setModels(aircraft_models);
            setIsLoading(false)
            return;
        }
        if(model.length < 1) {
            const { data: { aircraft_models }} = await aircraftApi.getModels(make , "", "");
            setModels(aircraft_models);
            setIsLoading(false)
            return;
        }
        const { data: { aircraft_models }} = await aircraftApi.getModels(make , model, "");
        setModels(aircraft_models);
        setIsLoading(false)
    }
    
    const debounceHandler = useCallback(debounce(filter, DEBOUNCE_TIME), []);

    const handleFiltering = (e) => {
        if(!e) return;
        const { value } = e.target;
        debounceHandler(make, value, "");
    }

    const handleAircraftPick = async (e, value) => {
        reset({...getValues(), year: null, min_value: 0, max_value: 550000})
    }

    const handleOnFocus = async () => {
        setIsLoading(true)
        const { data: { aircraft_models }} = await aircraftApi.getModels(make , "", "");
        setModels(aircraft_models);
        setIsLoading(false)
    }

    if (notFound) {
        return <Grid item xs={12} md={4}>
            <Typography variant="h4" className="gray">Aircraft model</Typography>
            <ControlledTextField fullWidth name="model" className="margin-top-8" placeholder="Model"/>
        </Grid>
    } else {   
        return (!isMobile || make !== '' ) ? <Grid item xs={12} md={4}>
        {make && <>
            <SkywatchInformationTooltip placement="bottom" text="Proper Model selection is critical! The distinction between models made by some manufacturers is very subtle. Errors made during model selection may affect the acceptability of the applications, the premiums quotes, or policy terms offered. Where errors are made, we must reserve our right to re-underwrite and re-rate based on proper model identification. When selecting the model, please be careful.">
                <Typography variant="h4" className="gray">Aircraft model</Typography>
            </SkywatchInformationTooltip>
            <BetterControlledAutocomplete isLoading={isLoading} name="model" onFocus={handleOnFocus} className="margin-top-8" onChange={handleAircraftPick} onInputChange={handleFiltering} placeholder="Model" options={models} disabled={locked_quote}/>
        </>}
        </Grid> : <div/>
    }
}

export default AircraftModelAutocomplete;